import { createContext } from 'react';

import { Staff } from '../../types';
import { StaffFilterSelection } from '../../components/StaffFilter/types';

export type StaffFilterContextType = {
  // Current user
  currentUser: Staff | null;
  isLoadingCurrentUser: boolean;
  // Unified selection (replaces both selectedStaff and assigned/all filter)
  selection: StaffFilterSelection;
  setSelection: (selection: StaffFilterSelection) => void;
  // Indicates if selection has been initialized (URL sync complete or default set)
  isSelectionInitialized: boolean;
  // Legacy: selectedStaff for backwards compatibility during transition
  selectedStaff: Staff | null;
  setSelectedStaff: (staff: Staff | null) => void;
  // Staff list data
  staffList: Staff[];
  isLoadingStaff: boolean;
  hasMoreStaff: boolean;
  // Actions
  searchStaff: (query: string) => void;
  loadMoreStaff: () => Promise<void>;
  searchQuery: string;
};

const defaultValue: StaffFilterContextType = {
  currentUser: null,
  isLoadingCurrentUser: false,
  selection: { type: 'everyone' },
  setSelection: () => {
    // Default noop
  },
  isSelectionInitialized: false,
  selectedStaff: null,
  setSelectedStaff: () => {
    // Default noop
  },
  staffList: [],
  isLoadingStaff: false,
  hasMoreStaff: false,
  searchStaff: () => {
    // Default noop
  },
  loadMoreStaff: async() => {
    // Default noop
  },
  searchQuery: '',
};

export const StaffFilterContext = createContext<StaffFilterContextType>(defaultValue);
